import { mapActions } from 'vuex'

export default {
  ...mapActions(['updateUserData', 'logout', 'user']),
  accountDisable () {
    this.$v.$touch()
    if (this.$v.credentials.current_password.$error) {
      this.hideErro()
      return
    }

    const credentials = {...this.credentials}

    this.$http.put('v1/professional/settings/profiles/me/account_disable', credentials)
    .then(({data}) => {
      if (data.active === false) {
        this.isDisabled = true
        this.showModalAccountDisabled = true
        this.showModalPassword = false
        this.userType = data.type
        this.doLogout()
      }
    })
    .catch(({data, meta}) => {
      this.isPasswordError = true
      this.errors = data
    })
  },
  hideErro () {
    this.isPasswordError = false
  },
  doLogout () {
    const isProfessional = (type) => {
      if (type === 'professional') {
        return true
      }
    }
    const isCompany = (type) => {
      if (type === 'company') {
        return true
      }
    }
    this.logout()
      .then(() => {
        if (isProfessional(this.userType)) {
          return this.$router.push({name: 'auth.professional.login'})
        }

        if (isCompany(this.userType)) {
          return this.$router.push({name: 'auth.company.login'})
        }

        window.location.href = '/'
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/components/disabled-account/resources/methods.js